import { render, staticRenderFns } from "./spReplaceRate.vue?vue&type=template&id=053450a3&scoped=true&"
import script from "./spReplaceRate.vue?vue&type=script&lang=js&"
export * from "./spReplaceRate.vue?vue&type=script&lang=js&"
import style0 from "./spReplaceRate.vue?vue&type=style&index=0&id=053450a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053450a3",
  null
  
)

export default component.exports